import React, {useContext, useState} from "react";
import MoreInfoCard from "./MoreInfoCard";
import {DataContext} from "../Context/DataContext";

import TruckIcon from "../Assets/Images/truck.svg";
import BookOpenIcon from "../Assets/Images/book-open.svg";
import ShoppingBagIcon from "../Assets/Images/shopping-bag.svg";

import leftArrow from "../Assets/Images/left-arrow.svg";
import rightArrow from "../Assets/Images/right-arrow.svg";

export default function MoreInfoSection() {
	// Show desktop or mobile design
	const {isMobile} = useContext(DataContext);

	// Which card to display
	const [shownCard, setShownCard] = useState(0);
	const [movePX, setMovePX] = useState(0);

	const goToCard = (direction) => {
		let leftPX = [0, -(308 + 10), -(308 + 10) * 2],
			newShownCard = shownCard;

		if (direction === "left") {
			if (shownCard - 1 < 0) newShownCard = 2;
			else newShownCard = shownCard - 1;
		} else newShownCard = (shownCard + 1) % 3;

		setShownCard(newShownCard);
		setMovePX(leftPX[newShownCard]);
	};

	const moreInfoCards = [
		<MoreInfoCard
			img={BookOpenIcon}
			title={"CAPACITACIONES"}
			description={"Ingresa a nuestros cursos gratuitos y conoce cómo funciona el comercio electrónico transfronterizo en las regiones sugeridas"}
			buttonContent={"Ir a los cursos"}
			type={"primary"}
			link={"https://exporta.online/preparate-para-exportar/"}
		/>,
		<MoreInfoCard
			img={ShoppingBagIcon}
			title={"IMPORTACIONES"}
			description={"Consulta las importaciones de tu partida arancelaria en los países sugeridos"}
			buttonContent={"Consultar"}
			type={"secondary"}
			link={"https://exporta.online/wp-content/uploads/2022/06/INSTRUCTIVO-3.pdf"}
		/>,
		<MoreInfoCard
			img={TruckIcon}
			title={"TRIBUTOS Y COSTOS"}
			description={"Consulta los tributos aduaneros y costos logísticos que deberás tener en cuenta para ingresar al país destino"}
			buttonContent={"Consultar"}
			type={"secondary"}
			link={"https://exporta.online/wp-content/uploads/2022/06/INSTRUCTIVO-2.pdf"}
		/>,
	];

	return (
		<div className='more-info-section'>
			<h2>Más información</h2>
			{isMobile ? (
				<div className='more-info-cards-mobile'>
					<img src={leftArrow} alt='Ver anterior' onClick={() => goToCard("left")}></img>
					<div className='cards-carousel'>
						<div style={{left: `${movePX}px`}}>{moreInfoCards}</div>
					</div>
					<img src={rightArrow} alt='Ver siguiente' onClick={() => goToCard("right")}></img>
					<div className='more-info-bar-card'>
						<div style={{backgroundColor: shownCard === 0 ? "var(--blue)" : "var(--blue-50)"}}></div>
						<div style={{backgroundColor: shownCard === 1 ? "var(--blue)" : "var(--blue-50)"}}></div>
						<div style={{backgroundColor: shownCard === 2 ? "var(--blue)" : "var(--blue-50)"}}></div>
					</div>
				</div>
			) : (
				<div className='more-info-cards-desktop'>{[moreInfoCards[1], moreInfoCards[0], moreInfoCards[2]]}</div>
			)}
		</div>
	);
}
